import React from 'react'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

const BORDER = '1px dashed #7fe1a7'

// The legend of the colours and marks (RN25, maqueta `.legend`). «Done» is the reused key of the finished state.
const ITEMS = [
  { key: 'Working / running', style: { background: '#1e88e5' } },
  { key: 'Pause (INTERRUPTED)', style: { background: '#ff8f00' } },
  { key: 'Stopped / no job', style: { background: '#616161' } },
  { key: 'Connected to the machine', style: { background: '#26a69a' } },
  { key: 'Done', style: { background: '#43a047' } },
  { key: 'Adjusted by a correction', style: { border: BORDER } },
  { key: 'Filled by a correction (nobody clocked it)', style: { border: BORDER, backgroundImage: 'repeating-linear-gradient(135deg, rgba(255,255,255,.25) 0 3px, transparent 3px 6px)' } },
  { key: 'Suspicious', style: { border: '2px solid #ff5a52' } }
]

const TimelineLegend = () => {
  const { t_ } = useSmartTranslation()
  return (
    <div className='dc-legend' role='list'>
      {ITEMS.map((item) => (
        <span key={item.key} role='listitem'><i style={item.style} />{t_(item.key)}</span>
      ))}
    </div>
  )
}

export default TimelineLegend
